import { css } from '@emotion/react';
import { fonts } from './fonts';
import { colors } from './colors';
import { breakpoints, mq } from './breakpoints';

export const signInCss = css`
  [data-amplify-container] {
    gap: 30px;
    border: none;
    opacity: 0px;
    box-shadow: 4px 4px 10px 0px #00000040;
    width: 755px;
    height: 638px;
    display: flex;
    align-self: center;

    & > div:first-of-type > svg {
      width: 253px;
      height: 70px;

      ${breakpoints.small} {
        width: 371px;
      }
    }

    ${breakpoints.small} {
        border: 1px solid #cacaca;
        border-radius: 1px;
      }
  }
  ,
  [data-amplify-authenticator] [data-amplify-router] {
    border-width: 0;
    border-radius: 10px;
    border: 0;
    box-shadow: 0;
  }

  [data-amplify-authenticator] {
    border-width: 0;
    border-radius: 10px;
    border: 0;
    box-shadow: 0;
    height: 100vh;
    width: 100%;
  }
  ,
  [data-amplify-router] {
    border-width: 0;
    border: 0;
    box-shadow: 0;
    width: 100%;

    ${breakpoints.small} {
      padding-right: 70px;
      padding-left: 70px;
    }
    
  }
  ,
  [data-amplify-authenticator]: {
    display: flex;
    flex: 1;
    align-items: center;
    height: 100vh;
  }
  ,
  [data-amplify-router-content] : {
    border: 0;
  }
  .amplify-button--primary {
    background: linear-gradient(338.15deg, #004a86 12.01%, #0068b5 83.38%);
  }
  ,
  [data-amplify-authenticator] {
    --amplify-components-authenticator-router-box-shadow: 0 0 0
      var(--amplify-colors-overlay-10);
    --amplify-components-authenticator-router-border-width: 0;
    --amplify-components-authenticator-form-padding: var(--amplify-space-medium)
      var(--amplify-space-xl) var(--amplify-space-xl);
    --amplify-components-fieldcontrol-focus-box-shadow: 0 0 0 0 var(--amplify-colors-purple-60);
    --amplify-components-tabs-item-active-border-color: var(--amplify-colors-neutral-100);
    --amplify-components-tabs-item-color: var(--amplify-colors-neutral-80);
    --amplify-components-tabs-item-active-color: var(--amplify-colors-purple-100);
    --amplify-components-button-link-color: var(--amplify-colors-purple-80);
  }
  ,
  [data-amplify-authenticator] [data-amplify-container] {
    width: 100%;
    min-height: 510px;
    height: fit-content;
    display: flex;
    align-items: center;
    flex-direction: column;

  ${breakpoints.small} {
      width: 605px;
  }
   
  }
    input[type="number"] {
  -moz-appearance: textfield; /* For Firefox */
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none; /* For Chrome, Safari, Edge, Opera */
}

.amplify-label{
...${fonts.largeLabel}
},
.amplify-button--link{
...${fonts.largeLabel}
color: ${colors.blue3}
},
.amplify-heading{
display:none
},
.amplify-button--primary.disabled {
  background-color: #d3d3d3; /* Light grey background */
  cursor: not-allowed; /* Change cursor to indicate disabled state */
  color: #a9a9a9; /* Light grey text */
}

/* ——— Mobile layer (appended LAST so the rules win in-sheet ties below
   992px; unreachable at >=992px). ——— */
${mq.mobile} {
  /* height:100vh (above) FIXES the box; when the card is taller than the
     visual viewport (852x393 landscape, ForceNewPassword with the rules
     list), Amplify's own grid centering (display:grid + place-self:center
     in @aws-amplify/ui styles.css) pushes the overflow above the top edge
     into unreachable negative scroll space. auto + min-height keeps the
     centered look for short content and grows for tall content, so the
     (document-scrolling) login page can always scroll to everything.
     The 100vh line is the fallback for engines without dvh. */
  [data-amplify-authenticator] {
    height: auto;
    min-height: 100vh;
    min-height: 100dvh;
  }

  /* The base pins the logo svg to 253x70 while its viewBox is 0 0 159 30
     (5.3:1) — the content letterboxes inside a 3.6:1 box, wasting ~22px
     of header height. Let height follow the intrinsic ratio. */
  [data-amplify-container] > div:first-of-type > svg {
    height: auto;
    aspect-ratio: 159 / 30;
  }
}

${mq.phone} {
  /* Below 768 the card is width:100% with no horizontal inset (the 70px
     router padding is >=992 only); give the header/footer slots and the
     420px reset-password footer copy a gutter. box-sizing is mandatory:
     the router is width:100% and the global default is content-box. */
  [data-amplify-router] {
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;
  }
}
`;
